import { withStyles } from '@material-ui/styles';
import ReportPage from 'appModule/reporting/component/ReportPDF/ReportPage';
import React from 'react';
const footer = require('../../../../../public/hb_powered_by_int.png');
import { withNamespaces } from 'react-i18next';

const styles = () => ({
  container: {
    backgroundColor: 'white',
    width: '21cm',
    height: '29.7cm',
    overflow: 'hidden',
  },
  metadataTitle: {
    width: '40%',
    fontSize: 12,
  },
  metadataValue: {
    width: '60%',
    fontSize: 12,
  },
  metadataSpace: {
    height: 5,
  },
  disclaimerContainer: {},
});
@withNamespaces('reports', { wait: true })
@withStyles(styles, { index: 1 })
export default class ReportingDisclaimerPage1 extends React.Component {
  constructor(props) {
    super(props);

    if (this.props.location.query['session-language']) {
      this.props.i18n.changeLanguage(this.props.location.query['session-language']);
    }
  }
  render() {
    const { page = 1, totalPages = 10 } = this.props.location.query;
    const { t } = this.props;
    return (
      <ReportPage page={page} totalPages={totalPages}>
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          <h2 style={{ marginTop: '130px' }}>{t('disclaimerTitle')}</h2>
          {/* Sub Title */}
          <div style={{ marginTop: '5px', textAlign: 'left' }}>
            <p style={{ lineHeight: '25px' }}>
             {t('disclaimerPage1')}
            </p>
          </div>
        </div>
      </ReportPage>
    );
  }
}
